import { isAfter, isBefore } from 'date-fns'

import CONSTANTS from '@/constants'
import { getSortedDateEntriesUtc } from '@/helpers/mixins/dateParsing'

const { LIVE_VIRTUAL_TRAININGS } = CONSTANTS

export const liveVirtualTrainingsHydratation = LVTCollection => {
  LVTCollection?.forEach(liveVirtualTraining => {
    liveVirtualTraining.product_type = 'live_virtual_training'
    switch (liveVirtualTraining.merchant_id) {
      case LIVE_VIRTUAL_TRAININGS.LVT_ADV_NET_AUTOMATION:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Rohit Pardasani',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
          dates: [{ startDate: '2026-08-10', endDate: '2026-08-12', schedule: '9am - 5pm ET' }],
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCIE_SECURITY:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Rohit Pardasani',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
          dates: [{ startDate: '2026-09-14', endDate: '2026-09-18', schedule: '9am - 5pm ET' }],
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CISCO_ACI:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Brian McGahan',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
          dates: [{ startDate: '2026-10-19', endDate: '2026-10-21', schedule: '10am - 4pm ET' }],
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCNP_ENCOR:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Keith Bogart',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
          dates: [
            { startDate: '2026-06-08', endDate: '2026-06-12', schedule: '10am - 4pm ET' },
            { startDate: '2026-11-16', endDate: '2026-11-20', schedule: '10am - 4pm ET' },
          ],
        })
        break
      case LIVE_VIRTUAL_TRAININGS.LVT_CCIE_EI:
        Object.assign(liveVirtualTraining, {
          instructorName: 'Brian McGahan',
          includedFeature: '+ 30 days of Premium',
          includedFeatureDetail: 'Starts on day 1 of training',
          dates: [
            { startDate: '2026-07-13', endDate: '2026-07-17', schedule: '10am - 4pm ET' },
            { startDate: '2026-12-07', endDate: '2026-12-11', schedule: '10am - 4pm ET' },
          ],
        })
        break
      default:
        break
    }
  })
  const getSortDate = lvt => {
    if (Array.isArray(lvt.dates) && lvt.dates.length > 0) {
      const sortedDates = getSortedDateEntriesUtc(lvt.dates)
      if (sortedDates.length > 0) {
        return sortedDates[0].start
      }
    }
    if (lvt.startDate && lvt.year) {
      return Date.parse(`${lvt.startDate}, ${lvt.year}`)
    }
    return null
  }

  LVTCollection?.sort((lvtA, lvtB) => {
    const sortDateA = getSortDate(lvtA)
    const sortDateB = getSortDate(lvtB)
    if (!sortDateA && !sortDateB) {
      return 0
    }
    if (!sortDateA) {
      return 1
    }
    if (!sortDateB) {
      return -1
    }
    if (isBefore(sortDateA, sortDateB)) {
      return -1
    }
    if (isAfter(sortDateA, sortDateB)) {
      return 1
    }
    return 0
  })
  if (Array.isArray(LVTCollection) && LVTCollection.length > 0) {
    LVTCollection[0].upNext = true
  }
}
